import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const MuiCheckbox = React.forwardRef((props: any, ref: any) => {
  const { label, name } = props;
  return (
    <FormControlLabel style={{ marginLeft: "10px", paddingTop: "20px" }}
      control={<Checkbox name={name} {...props} />}
      label={label}
    />
  );
});

function FormCheckBox(props: any) {
  const { control } = useFormContext();
  const { name, required } = props;
  return (
    <React.Fragment>
      <Controller
        render={({ field }) => (
          <MuiCheckbox
            {...field}
            {...props}
          />
        )}
        name={name}
        control={control}
        rules={{ required: required || false }}
        defaultValue={false}
      />
    </React.Fragment>
  );
}

export default FormCheckBox;
